import { useTranslation } from "react-i18next";

const LegalSimpliFooter = ({ privacyPolicy, termsOfUse, contactUs }) => {
  const { t } = useTranslation();
  return (
    <div className="legalsimpli-footer h-16 pb-[160px]  md:pb-0">
      <div className="flex justify-center border-t-2 divide-x-2 divide-text-gray-900 gap-x-4 text-[#424a5b] text-xs md:text-sm p-2">
        <a href={privacyPolicy}>{t("footer.ls.privacy_policy")}</a>
        <a className="pl-2" href={termsOfUse}>
          {t("footer.ls.terms_condition")}{" "}
        </a>
        <a className="pl-3" href={contactUs}>
          {t("footer.ls.contact_us")}
        </a>
      </div>
      <div className="text-center text-gray-500 text-[11px] p-2 md:p-0 md:text-xs font-semibold">
        © {new Date().getFullYear()}{" , "}{t("footer.ls.subsidiary")}{" "}
        <a
          rel="nofollow noopener noreferrer"
          href="https://www.solidframework.net/"
          target="_blank"
        >
          <span className="text-gray-700 md:text-gray-800">
            {" "}
            {t("footer.ls.solid_doc")}
          </span>
        </a>
        {t("footer.ls.and")}
        <a
          rel="nofollow noopener noreferrer"
          href="https://www.aspose.com"
          target="_blank"
        >
          <span className="text-gray-700 md:text-gray-800">
            {t("footer.ls.aspose")}
          </span>{" "}
        </a>
        .
      </div>
    </div>
  );
};

export default LegalSimpliFooter;
